<template>
  <div class="card w-100" v-if="!loading && dogDocuments !== null">
    <div class="card-body mb-0 pb-0 mi-card">
      <h5 class="card-title text-left text-muted">
        {{ $t("documentos") }}
        <button
          v-tooltip="{
            content: addNewDocument === true ? $t('cancelar') : $t('nuevo'),
          }"
          class="btn btn-sm float-right btn-gr"
          :class="{
            'btn-outline-warning': addNewDocument,
            'btn-outline-success': !addNewDocument,
          }"
          @click="addNewDocument = !addNewDocument"
        >
          <i v-if="!addNewDocument" class="fa fa-plus" aria-hidden="true"></i>
          <i v-else class="fa fa-minus" aria-hidden="true"></i>
        </button>
      </h5>
    </div>
    <!-- component nuevo documento -->
    <div class="card-body" v-if="addNewDocument">
      <upload-dog-file :dogId="dogId"></upload-dog-file>
    </div>
    <!-- listado de documentos -->
    <div class="card-body pt-0 pb-0">
      <div class="row">
        <div class="col-md-12" v-if="dogDocuments.length > 0">
          <div class="responsive">
            <table class="table">
              <thead>
                <tr>
                  <td class="text-left hidden-xs">{{ $tc("fecha", 1) }}</td>
                  <!-- <td>&nbsp;</td> -->
                  <!--    <td class="text-left">{{ $t('nombre') }}</td> -->
                  <td class="text-left">{{ $t("tipo documento") }}</td>
                  <td class="text-right">{{ $t("acciones") }}</td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="doc in dogDocuments"
                  :key="doc.id"
                  class="border-bottom"
                >
                  <td class="text-left pb-0  hidden-xs">
                    {{ doc.created_at | filterDate }}
                  </td>
                  <!--       <td class="text-left pb-0">{{doc.id}}</td> -->
                  <!--      <td class="text-left">{{doc.name}}</td> -->
                  <td class="text-left">{{ $t(doc.doc_type.name) }}</td>

                  <!-- botones -->
                  <td>
                    <div class="btn-group float-right" role="group">
                      <button
                        v-tooltip="{
                          content:
                            doc.validated === 1
                              ? $t('validado')
                              : $t('no validado'),
                        }"
                        type="button"
                        class="btn btn-sm btn-gr disabled"
                        :class="{
                          'btn-outline-success': doc.validated !== 0,
                          'btn-outline-danger': doc.validated === 0,
                        }"
                      >
                        <i
                          class="fa fa-thumbs-o-up"
                          :class="{
                            'fa-thumbs-o-up': doc.validated !== 0,
                            'fa-thumbs-o-down': doc.validated === 0,
                          }"
                          aria-hidden="true"
                        >
                        </i>
                      </button>

                      <button
                        v-tooltip="{ content: $t('ver') }"
                        type="button"
                        class="btn btn-sm btn-outline-secondary btn-gr"
                        @click.prevent="viewThisDocument(doc.id)"
                      >
                        <i class="fa fa-eye" aria-hidden="true"></i>
                      </button>

                      <button
                        v-tooltip="{ content: $t('descargar') }"
                        type="button"
                        class="btn btn-sm btn-outline-secondary btn-gr"
                        @click.prevent="downloadThisDocument(doc.id)"
                      >
                        <i class="fa fa-download" aria-hidden="true"></i>
                      </button>

                      <button
                        v-tooltip="{ content: $t('eliminar') }"
                        type="button"
                        class="btn btn-sm btn-outline-secondary btn-gr"
                        @click.prevent="deleteThisDocument(doc.id)"
                      >
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 pt-2 px-0" v-else>
          <div class="alert alert-success p-2 mb-2 mx-0">
            <p>{{ $t("no existen documentos registrados") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="downloadDoc !== null">
      <img :src="imageView" />
      {{ fileDocument.type }}
    </div>
    <a
      v-if="downloadDoc !== null"
      ref="enlace"
      :href="downloadDoc"
      :download="downloadDoc"
      >guardar</a
    >
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import UploadDogFile from "@/components/layouts/general/Upload-dog-file";

export default {
  name: "Dog-Document-component",
  components: { UploadDogFile },
  props: ["dogId"],
  data() {
    return {
      addNewDocument: false,
      downloadDoc: null,
      downloading: false,
    };
  },
  methods: {
    ...mapActions("files", [
      "getDogDocuments",
      "getOneDocument",
      "deleteDataDoc",
    ]),
    viewThisDocument(docId) {
      this.getOneDocument(docId);
    },
    downloadThisDocument(docId) {
      this.downloading = true;
      this.getOneDocument(docId);
    },
  },
  computed: {
    ...mapState("files", ["loading", "dogDocuments", "fileDocument"]),
    contadorDocs: function () {
      if (this.dogDocuments !== null) {
        return this.dogDocuments.length;
      } else {
        return 0;
      }
    },

    imageView: function () {
      if (this.fileDocument === null) return;

      if (this.fileDocument.type.indexOf("image") > -1) {
        return URL.createObjectURL(this.fileDocument);
      } else {
        var mypdf = URL.createObjectURL(this.fileDocument);
        window.open(mypdf, "_blank");
        return mypdf;
      }

      /* if (this.fileDocument.type.indexOf("image") > -1 ) {         
          return URL.createObjectURL(this.fileDocument);
        } else {
          var mipdf = URL.createObjectURL(this.fileDocument);
          if (this.downloading === false) {
            window.open(mipdf,"_blank");
            return mipdf; 
          } else {
            //this.downloading = false;
            this.downloadDoc = mipdf;
            //this.$refs.enlace.click();
            return mipdf;
          }
        }   */
    },
  },
  watch: {
    fileDocument: function () {
      this.downloadDoc = URL.createObjectURL(this.fileDocument);
      console.log("cambios en filedocument");
      if (this.downloading === true) {
        //this.$refs.enlace.click();
        console.log("entro porque estoy descargando");
        var element = document.createElement("a");
        element.setAttribute("href", this.downloadDoc);
        element.setAttribute("download", this.downloadDoc);
        element.click();
        this.downloading = false;
        //this.$refs.enlace.click();
      }
    },
  },
  mounted() {
    this.getDogDocuments(this.dogId);
  },
  destroyed() {
    // Destruir el objeto FileDocument
    this.deleteDataDoc();
  },
};
</script>

<style scoped>
tr > td {
  padding-bottom: 1px;
  padding-top: 8px;
  font-size: 0.75em;
}
.mi-card {
  font-size: 0.7em;
}
</style>
